import { useContent } from "@/shared/lib/i18n";

const FEATURE_ICONS = [
  "/icons/design.svg",
  "/icons/payouts.svg",
  "/icons/copy-trading.svg",
  "/icons/ai-trading.svg",
];

export function NewGenOffer() {
  const { newGenOffer } = useContent();
  const titleLines = newGenOffer.title.split("\n");

  return (
    <section className="py-16 px-[14px] lg:py-24 lg:px-8" id="platform">
      <div className="mx-auto max-w-[1760px]">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-stretch">
          {/* Left: Platform mockup — hidden on mobile (shown inline below) */}
          <div className="hidden lg:flex relative bg-[#8C8C8C]/15 items-center justify-center rounded-lg px-10 lg:order-1">
            <img src="/illustration.png" alt="Platform illustration" className="w-full" />
          </div>

          {/* Right: Content */}
          <div className="lg:order-2">
            <h2 className="font-display text-[32px] lg:text-[48px] leading-tight text-white mb-4">
              {titleLines[0]}
              <br />
              {titleLines[1]}
            </h2>
            <p className="text-[20px] leading-relaxed mb-6 lg:mb-10 lg:max-w-[589px]">
              {newGenOffer.subtitle}
            </p>

            {/* Illustration — mobile only, between subtitle and features */}
            <div className="lg:hidden mb-6">
              <img src="/illustration.png" alt="Platform illustration" className="w-full" />
            </div>

            <div className="flex flex-col gap-4 lg:gap-6">
              {newGenOffer.features.map((f, i) => (
                <div
                  key={f.title}
                  className="flex items-start gap-4 bg-[#8C8C8C]/15 backdrop-blur-[10px] rounded-lg p-4"
                >
                  <div className="w-16 h-16 rounded-[20px] bg-[#8C8C8C]/15 border border-[#8C8C8C]/15 flex items-center justify-center shrink-0 mt-0.5">
                    <img src={FEATURE_ICONS[i]} alt="" className="w-10 h-10" />
                  </div>
                  <div>
                    <p className="text-[20px] lg:text-[24px] font-semibold text-white mb-1">{f.title}</p>
                    <p className="text-[15px] lg:text-[16px] text-muted-fg leading-relaxed">{f.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
